import type { UpdateCarrierDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateCarriersQuery } from "./use-carriers-query";

export function useEditCarrierTransport(shopId: string) {
  const invalidateShop = useInvalidateCarriersQuery({ shopId });

  return useApiMutation(
    "patch",
    "/shops/{shopId}/carriers/{carrierId}",
    {
      invalidate: invalidateShop,
      mapVariables: ({
        carrier,
        carrierId,
      }: {
        carrier: UpdateCarrierDto;
        carrierId: string;
      }) => ({
        params: { path: { shopId, carrierId } },
        body: carrier,
      }),
    },
  );
}
